import styles from './Type.module.less';
export var useTypeStyles = function useTypeStyles() {
  return {
    className: styles.type
  };
};